import { cn } from "@/lib/utils.ts";

const getClipPath = (done: number) => {
  const progress = done * 3.6;
  const centerX = 50;
  const centerY = 50;
  const radius = 100;

  if (progress === 0) {
    return "polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%, 50% 0%)";
  }
  if (progress >= 360) {
    return "polygon(50% 50%, 50% 0%, 50% 0%)";
  }

  const remainingProgress = 360 - progress;
  const angle = (-remainingProgress - 90) * (Math.PI / 180);
  const endX = centerX + radius * Math.cos(angle);
  const endY = centerY + radius * Math.sin(angle);

  let polygon = `polygon(${centerX}% ${centerY}%, ${centerX}% 0%`;

  if (remainingProgress > 45) {
    polygon += `, 0% 0%`;
  }
  if (remainingProgress > 135) {
    polygon += `, 0% 100%`;
  }
  if (remainingProgress > 225) {
    polygon += `, 100% 100%`;
  }
  if (remainingProgress > 315) {
    polygon += `, 100% 0%`;
  }

  polygon += `, ${endX}% ${endY}%)`;

  return polygon;
};

export const ProgressRadial = ({
  progress,
  className,
}: {
  progress: number;
  className: string;
}) => (
  <div
    className={cn("", className)}
    style={{
      clipPath: getClipPath(progress),
    }}
  />
);
